import {useSelector} from 'react-redux';

/**
 * The current user's phone number.
 * @returns {string|undefined} The current user's phone number.
 */
export const usePhoneNumber = () => useSelector(state => state.user.user.phone_number);
